<template>
  <div class="hobl-tabs">
    <div class="hobl-tabs__tabs-row">
      <div
        class="hobl-tabs__tab"
        @click="activeTab = 0"
        :class="{ 'hobl-tabs__tab_active': activeTab === 0 }"
      >
        <div class="hobl-tabs__tab-icon">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="19.5" stroke="#003865" />
            <path
              d="M22.3179 11.3023C22.3179 12.4547 21.3836 13.389 20.2312 13.389C19.0788 13.389 18.1445 12.4547 18.1445 11.3023C18.1445 10.1499 19.0788 9.21564 20.2312 9.21564C21.3836 9.21564 22.3179 10.1499 22.3179 11.3023Z"
              stroke="#003865"
            />
            <path
              d="M30.812 20.2668C30.812 21.4192 29.8778 22.3534 28.7253 22.3534C27.5729 22.3534 26.6387 21.4192 26.6387 20.2668C26.6387 19.1143 27.5729 18.1801 28.7253 18.1801C29.8778 18.1801 30.812 19.1143 30.812 20.2668Z"
              stroke="#003865"
            />
            <path
              d="M22.3179 28.6976C22.3179 29.85 21.3836 30.7843 20.2312 30.7843C19.0788 30.7843 18.1445 29.85 18.1445 28.6976C18.1445 27.5452 19.0788 26.6109 20.2312 26.6109C21.3836 26.6109 22.3179 27.5452 22.3179 28.6976Z"
              stroke="#003865"
            />
            <path
              d="M13.7143 24.9019C13.7143 26.0543 12.7801 26.9886 11.6277 26.9886C10.4752 26.9886 9.54102 26.0543 9.54102 24.9019C9.54102 23.7495 10.4752 22.8152 11.6277 22.8152C12.7801 22.8152 13.7143 23.7495 13.7143 24.9019Z"
              stroke="#003865"
            />
            <path
              d="M13.7143 14.7864C13.7143 15.9389 12.7801 16.8731 11.6277 16.8731C10.4752 16.8731 9.54102 15.9389 9.54102 14.7864C9.54102 13.634 10.4752 12.6998 11.6277 12.6998C12.7801 12.6998 13.7143 13.634 13.7143 14.7864Z"
              stroke="#003865"
            />
            <path
              d="M21.8145 19.2313C21.8145 20.1089 21.1031 20.8202 20.2256 20.8202C19.3481 20.8202 18.6367 20.1089 18.6367 19.2313C18.6367 18.3538 19.3481 17.6425 20.2256 17.6425C21.1031 17.6425 21.8145 18.3538 21.8145 19.2313Z"
              stroke="#003865"
            />
            <path d="M13.8535 13.4668L17.7335 11.969" stroke="#003865" />
            <path d="M22.0449 13.1512L26.8805 18.4534" stroke="#003865" />
            <path d="M27.1428 22.3112L22.0762 26.8846" stroke="#003865" />
            <path d="M13.0488 16.9465L18.6266 26.6709" stroke="#003865" />
            <path d="M13.916 26.1069L17.6449 27.8358" stroke="#003865" />
            <path d="M12.5957 22.5019L18.8313 13.4753" stroke="#003865" />
            <path d="M14.0098 15.8002L18.3742 18.2669" stroke="#003865" />
            <path d="M22.3203 19.4664L26.1381 19.7553" stroke="#003865" />
            <path d="M20.2266 21.3246L20.231 26.1068" stroke="#003865" />
          </svg>
        </div>
        <div class="hobl-tabs__tab-text">
          Патогенез<sup style="color: #32768a">1,10</sup>
        </div>
      </div>
      <div
        class="hobl-tabs__tab"
        @click="activeTab = 1"
        :class="{ 'hobl-tabs__tab_active': activeTab === 1 }"
      >
        <div class="hobl-tabs__tab-icon">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="19.5" stroke="#003865" />
            <path
              d="M15.8824 16.3824H16.3824V15.8824V10.5H23.6176V15.8824V16.3824H24.1176H29.5V23.6176H24.1176H23.6176V24.1176V29.5H16.3824V24.1176V23.6176H15.8824H10.5V16.3824H15.8824Z"
              stroke="#003865"
            />
          </svg>
        </div>
        <div class="hobl-tabs__tab-text">Патофизиология</div>
      </div>
    </div>
    <div
      class="hobl-tabs__body"
      v-for="body in 2"
      :key="body"
      v-show="activeTab === body - 1"
    >
      <div
        class="hobl-tabs__block"
        v-for="(block, ind) in modals[activeTab]"
        :key="ind"
      >
        <div class="hobl-tabs__block-title" v-html="block.title"></div>
        <div
          class="
            d-inline-flex
            px-4
            ml-auto
            hobl-tabs__block-button
            button button_empty-pink button_small
          "
          @click="currentModal = ind"
        >
          Подробнее
          <svg
            class="ml-2"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 3L11 8L6 13" stroke="#830051" stroke-linecap="square" />
          </svg>
        </div>
      </div>
    </div>
    <div class="hobl-tabs__modal" v-if="currentModal !== null">
      <div class="hobl-tabs__modal-overlay" @click="currentModal = null"></div>
      <div class="hobl-tabs__modal-content">
        <div class="hobl-tabs__modal-head">
          <div
            class="hobl-tabs__modal-title"
            v-html="modals[activeTab][currentModal].title"
          ></div>
          <div class="hobl-tabs__modal-close" @click="currentModal = null">
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 7L25 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path
                d="M25 7L7 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
            </svg>
          </div>
        </div>
        <div
          class="hobl-tabs__modal-body"
          v-html="modals[activeTab][currentModal].text"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";
export default {
  name: "HoblTabs",
  data: () => ({
    activeTab: 0,
    currentModal: null,
  }),
  computed: {
    modals() {
      return [
        [
          {
            title: "Оксидативный стресс",
            text: `Оксидативный стресс является одним из основных пусковых механизмов ХОБЛ. Биомаркеры оксидативного стресса увеличиваются в выдыхаемом воздухе, мокроте и в системном кровотоке у пациентов с ХОБЛ. Оксидативный стресс усиливается в периоды обострения заболевания. Оксиданты вырабатываются в ответ на вдыхание сигаретного дыма и других раздражающих веществ. Также может иметь место уменьшение количества эндогенных антиоксидантов<sup style="color: #32768a">19</sup>.`,
          },
          {
            title: "Воспалительные медиаторы",
            text: `Воспалительные медиаторы, уровень которых значительно увеличен при ХОБЛ, привлекают провоспалительные клетки из системного, в результате чего усиливается воспалительный процесс и запускается структурная перестройка дыхательных путей<sup style="color: #32768a">20,21</sup>.`,
          },
          {
            title: "Патоморфологические изменения",
            text: `Патоморфологические изменения при ХОБЛ происходят в дыхательных путях, паренхиме лёгких и в сосудах лёгких. Эти изменения включают: хроническое воспаление с увеличенным числом специфических типов клеток и структурные изменения. Воспалительные и структурные изменения в дыхательных путях усиливаются с утяжелением заболевания и персистируют при отказе от курения<sup style="color: #32768a">22</sup>.`,
          },
          {
            title: "Воспалительные клетки",
            text: `ХОБЛ характеризуется специфическим видом воспаления, включающее увеличенное число CD8+ (цитотоксических) Тс1 лимфоцитов, обнаруживаемых только у курильщиков с развившимся заболеванием. Эти клетки совместно с макрофагами и нейтрофилами являются активными участниками воспалительного процесса при ХОБЛ<sup style="color: #32768a">23,24</sup>.`,
          },
          {
            title: "Дисбаланс в системе протеиназы-антипротеиназы",
            text: `Существуют убедительные данные о том, что в легких у больных ХОБЛ нарушен баланс между протеиназами, расщепляющими компоненты соединительной ткани, и антипротеиназами, защищающими от действия протеиназ. При ХОБЛ повышается уровень нескольких видов протеиназ, образующихся в воспалительных и эпителиальных клетках. Опосредованное протеиназами разрушение эластина, главного соединительнотканного компонента паренхимы легких, служит важной характерной особенностью эмфиземы и, вероятно, является необратимым<sup style="color: #32768a">10</sup>.`,
          },
        ],
        [
          {
            title: "Ограничение воздушного потока",
            text: `Воспаление и сужение периферических дыхательных путей ведёт к снижению показателя ОФВ1. Деструкция паренхимы с последующим развитием эмфиземы также приводит к ограничению воздушного потока и ведёт к снижению трансопрта газов<sup style="color: #32768a">21</sup>. Обструкция периферических дыхательных путей приводит к задержке выдыхаемого воздуха и, как следствие, к гиперинфляции<sup style="color: #32768a">27</sup>. В основе лёгочной гиперинфляции лежит воздушная ловушка, которая развивается из-за неполного опорожнения альвеол во время выдоха вследствие потери эластической тяги лёгких или вследствие недостаточного времени выдоха в условиях выраженного ограничения экспираторного воздушного потока. Гиперинфляция уменьшает ёмкость вдыхаемого воздуха таким образом, что функциональная остаточная ёмкость лёгких возрастает во время физической нагрузки (динамическая гиперинфляция), что проявляется в усилении диспноэ и ограничении физической активности. Вышеперечисленные факторы приводят к ухудшению сократительной способности дыхательной мускулатуры. Гиперинфляция развивается на ранних этапах заболевания и является основным механизмом развития диспноэ при физической нагрузке<sup style="color: #32768a">28,29</sup>.`,
          },
          {
            title: "Нарушение обмена газов",
            text: `Нарушение обмена газов приводит к гипоксемии и гиперкапнии. В целом, перенос кислорода и оксида углерода ухудшается при прогрессировании заболевания. Несоответствие альвеолярной вентиляции и сниженной васкуляризации сосудистого ложа ухудшает нарушения в вентиляционно-перфузионном соотношении<sup style="color: #32768a">30</sup>.`,
          },
          {
            title: "Гиперсекреция слизи",
            text: `Гиперсекреция слизи, приводящая к хроническому продуктивному кашлю, является характерной особенностью хронического бронхита и не обязательно сочетается с ограничением скорости воздушного потока. Напротив, симптомы гиперсекреции слизи обнаруживаются не у всех пациентов с ХОБЛ. Если гиперсекреция имеется, она обусловлена метаплазией слизистой с увеличением количества бокаловидных клеток и размеров подслизистых желез в ответ на хроническое раздражающее действие на дыхательные пути сигаретного дыма и других вредных агентов. Гиперсекрецию слизи стимулируют различные медиаторы и протеиназы; многие из них действуют путём активации рецептора эпидермального фактора роста<sup style="color: #32768a">22</sup>.`,
          },
          {
            title: "Легочная гипертензия",
            text: `Легочная гипертензия может развиваться на поздних стадиях течения ХОБЛ. Она развивается вследствие гипоксической вазоконстрикции легочных артерий малого калибра. Прогрессирующая легочная гипертензия может приводить к гипертрофии правых отделов сердца и правожелудочковой сердечной недостаточности<sup style="color: #32768a">31</sup>.`,
          },
          {
            title: `Системные проявления ХОБЛ<sup style="color: #32768a">25,26</sup>`,
            text: `Системные проявления ХОБЛ. Ограничение скорости воздушного потока и особенно гиперинфляция оказывают отрицательное влияние на функцию сердца и газообмен. Повышенный уровень провоспалительных цитокинов в системном кровотоке приводит к утрате массы скелетной мускулатуры и кахексии, и может инициировать ухудшение течения сопутствующих заболеваний таких, как:
            <br>
            <br>
            <ul>
            <li>Ишемическая болезнь сердца;</li>
            <li>Сердечная недостаточность;</li>
            <li>Остеопороз;</li>
            <li>Анемия нормобластная;</li>
            <li>Эндокринологические заболевания;</li>
            <li>Метаболический синдром;</li>
            <li>Депрессия.</li>
            </ul>`,
          },
        ],
      ];
    },
  },
  watch: {
    currentModal() {
      bus.$emit("scrollLock", this.currentModal !== null);
    },
  },
};
</script>

<style lang="scss" scoped>
.hobl-tabs {
  &__tabs-row {
    margin-bottom: -8px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;

    @media screen and (max-width: 767px) {
      column-gap: 16px;
    }
  }

  &__tab {
    margin-bottom: 16px;
    padding: 16px 24px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #d2d2d2;
    transition: 0.3s;
    border-radius: 8px;
    cursor: pointer;

    @media screen and (max-width: 767px) {
      padding: 16px 8px;
    }

    &_active {
      border-radius: 8px 8px 0 0;
      margin-bottom: 0;
      background-color: #d6e4e8;
      border-color: #d6e4e8;
      padding-bottom: 32px;
    }

    &-text {
      font-family: "Roboto Slab", sans-serif;
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      margin-left: 8px;
      color: #3c4242;

      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  &__body {
    padding: 24px;
    border-radius: 8px;
    background-color: #d6e4e8;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media screen and (max-width: 767px) {
      grid-template-columns: 100%;
    }
  }

  &__block {
    padding: 16px 24px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #d2d2d2;
    transition: 0.3s;
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &:last-child {
      grid-column-start: 1;
      grid-column-end: 3;

      @media screen and (max-width: 767px) {
        grid-column-start: auto;
        grid-column-end: auto;
      }
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #3c4242;
      margin-bottom: 16px;
    }
  }

  &__modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999999999999;

    &-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      overflow: hidden;
    }

    &-content {
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 2;
      transform: translate(-50%, -50%);
      max-height: 80%;
      max-width: 800px;
      width: 100%;
      height: fit-content;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 1219px) {
        max-width: 90%;
      }
    }

    &-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 16px 24px;
      border-radius: 8px 8px 0 0;
      background-color: #32768a;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
      color: #fff;
      margin-right: 16px;
    }

    &-close {
      margin-left: auto;
      cursor: pointer;
    }

    &-body {
      padding: 24px;
      border-radius: 0 0 8px 8px;
      background-color: #fff;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #3c4242;
      overflow-y: auto;
    }
  }
}
</style>